import { mediaClient, DomainType } from "@/lib/request";
import { CommonRequestParams } from "@/types/commonParams";
import { SupplyCard } from "@/types/supplyList";
import { ssrFetch } from "@/lib/ssrFetch";
import { CODE_ENV, CURRENT_CODE_ENV } from "@/lib/constant";

/**
 * 供给相关API路径
 */
const SUPPLY_API_PATHS = {
  // 供给列表
  SUPPLY_LIST: '/fulishemini/lianmeng/supply/list',
} as const;

// 导出路径常量供外部使用
export { SUPPLY_API_PATHS };

export interface SupplyListRequestParams extends CommonRequestParams {
  // _ver: string;
  // platform: number;
  offset: number;
  limit: number;
  // cityId: number;
  // userId: string;
  // uuid: string;
  // lng: number;
  // lat: number;
  // wxOpenId?: string;
  // osType: string;
  // osVersion: string;
  // addrLng: number;
  // addrLat: number;
  bizScene: number;
  requestId: string | null;
  tabId: number | null;
  tabType: number | null;
  wayneId: number | null; // 韦恩ID
  segmentIdList: number[] | null; // 数据片ID列表
  quickId?: string | number | null;
  latitude: number | null;
  longitude: number | null;
  addrLatitude: number | null;
  addrLongitude: number | null;
  // ctype: string;
  containerVersion: string | null;
}

export interface SupplyListResponse {
  requestId: string;
  supplyCardList: SupplyCard[];
  isLastPage: boolean;
  rankTraceId: string;
}

/**
 * 获取供给列表
 * @param params 
 * @returns 
 */
export async function getSupplyList(params: SupplyListRequestParams) {
  return mediaClient.post<SupplyListRequestParams, SupplyListResponse>({
    url: SUPPLY_API_PATHS.SUPPLY_LIST,
    data: params,
  });
}

/**
 * =====================================================
 * SSR兼容函数
 * =====================================================
 */

/**
 * SSR环境获取商品供给列表
 * 与CSR完全一致的API设计：只接收一个业务参数
 * @param requestParams 请求参数（包含commonParams和业务参数）
 * @returns 商品供给列表完整响应
 */
export async function fetchSupplyListForSSR(
  requestParams: SupplyListRequestParams
): Promise<SupplyListResponse> {
  // 测试环境设置超时时间为 10 秒
  const timeout = CURRENT_CODE_ENV === CODE_ENV.TEST ? 10000 : undefined;
  
  const response = await ssrFetch.post<SupplyListResponse, SupplyListRequestParams>(
    DomainType.MEDIA,
    SUPPLY_API_PATHS.SUPPLY_LIST,
    requestParams,
    { timeout }
  );

  // 返回完整响应结构,与CSR保持一致
  return response?.data;
}
